import React, { useEffect, useMemo, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export default function IdCard() {
  const { registration_id } = useParams();
  const [issued, setIssued] = useState(null);
  const [error, setError] = useState(null);
  const regId = registration_id || (() => {
    try { return localStorage.getItem('gop_registration_id'); } catch (e) { return null; }
  })();

  useEffect(() => {
    if (!regId) return;
    axios.post(`${API}/student/id-card/issue/${regId}`).then(r => setIssued(r.data))
      .catch(e => setError(e.response?.status === 403
        ? 'Your membership is not active yet — please complete payment first.'
        : 'Could not issue an ID card.'));
  }, [regId]);

  if (!regId) return <Navigate to="/register" replace />;
  const pngUrl = `${BACKEND}/api/student/id-card/${regId}.png`;
  const pdfUrl = `${BACKEND}/api/student/id-card/${regId}.pdf`;
  const APP_BASE = (process.env.REACT_APP_APP_BASE_URL || '').replace(/\/$/, '')
    || (typeof window !== 'undefined' ? window.location.origin : '');
  const verifyUrl = issued ? `${APP_BASE}/verify/${issued.serial}` : '';

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8" data-testid="id-card-page">
      <div className="max-w-2xl mx-auto space-y-5">
        <div className="flex items-center gap-3">
          <img
            src="/brand/crest_flat.png"
            alt="Genius One Plus crest"
            className="h-12 w-auto"
            data-testid="id-card-brand-crest"
          />
          <div>
            <h1 className="text-3xl font-bold">Your membership card</h1>
            <p className="text-sm text-muted-foreground">Print at home or save to your phone wallet.</p>
          </div>
        </div>

        {error && <Card><CardContent className="p-4 text-red-600">{error}</CardContent></Card>}

        {issued && (
          <>
            <Card><CardContent className="p-3">
              <img src={pngUrl} alt="Membership card"
                   className="w-full rounded-lg shadow-lg"
                   data-testid="id-card-preview-img" />
            </CardContent></Card>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
              <Button asChild data-testid="download-png-btn">
                <a href={pngUrl} download={`${issued.serial}.png`}>⬇ Download PNG</a>
              </Button>
              <Button asChild variant="outline" data-testid="download-pdf-btn">
                <a href={pdfUrl} download={`${issued.serial}.pdf`}>⬇ Download PDF</a>
              </Button>
              <Button variant="outline" onClick={() => { navigator.clipboard.writeText(verifyUrl); alert('Verify link copied.'); }}
                      data-testid="copy-verify-btn">
                📋 Share verify link
              </Button>
            </div>
            <Card><CardHeader><CardTitle className="text-base">How to use</CardTitle></CardHeader>
              <CardContent className="text-sm space-y-1">
                <p>• Show the QR code to your teacher — they scan it and see live status.</p>
                <p>• Serial: <strong>{issued.serial}</strong></p>
                <p>• Verify URL: <code className="text-xs break-all">{verifyUrl}</code></p>
              </CardContent></Card>
          </>
        )}
      </div>
    </div>
  );
}
